var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCamera(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 6C3.44772 6 3 6.44772 3 7V17C3 17.5523 3.44772 18 4 18H14C14.5523 18 15 17.5523 15 17V15.9343C15 14.7362 16.3352 14.0216 17.3321 14.6862L21 17.1315V6.86852L17.3321 9.31382C16.3352 9.97837 15 9.26378 15 8.06574V7C15 6.44772 14.5523 6 14 6H4ZM1 7C1 5.34315 2.34315 4 4 4H14C15.6569 4 17 5.34315 17 7V7.13148L19.8906 5.20442C21.2197 4.31834 23 5.27112 23 6.86852V17.1315C23 18.7289 21.2197 19.6817 19.8906 18.7956L17 16.8685V17C17 18.6569 15.6569 20 14 20H4C2.34315 20 1 18.6569 1 17V7Z",
    fill: "#0F0F0F"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCamera);
export default __webpack_public_path__ + "static/media/camera.7be2b60362465ea5d62aee5948ce7354.svg";
export { ForwardRef as ReactComponent };